import { CompanyNotification } from "../model/notificationModel";
import { CompanyNotificationAction } from "./notification.action";

export interface NotificationState {
  notifications: CompanyNotification[];
  loading: boolean;
  error: string | null;
  notification_type?: string;
  is_read?: boolean;
  priority?: string;
  limit: number;
  offset: number;
  total: number;
  unread_count: number;
  currentPage: number;
}
export const initialState: NotificationState = {
  notifications: [],
  loading: false,
  error: null,
  limit: 5,
  offset: 0,
  total: 0,
  currentPage: 1,
  unread_count: 0,
};
export const companyNotificationReducer = (
  state: NotificationState = initialState,
  action: CompanyNotificationAction,
): NotificationState => {
  switch (action.type) {
    case "SET_NOTIFICATION_DATA":
      return {
        ...state,
        notifications: action.payload,
      };
    case "SET_TOTAL":
      return { ...state, total: action.payload };
    case "SET_UNREAD":
      return { ...state, unread_count: action.payload };
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "SET_IS_READ":
      return { ...state, is_read: action.payload };
    case "SET_CURRENT_PAGE":
      return { ...state, currentPage: action.payload };
    case "MARK_ONE_READ":
      return {
        ...state,
        notifications: state.notifications.map((n) =>
          n.id === action.payload ? { ...n, is_read: true } : n,
        ),
        unread_count: Math.max(0, state.unread_count - 1),
      };
    case "MARK_ALL_READ":
      return {
        ...state,
        notifications: state.notifications.map((n) => ({ ...n, is_read: true })),
        unread_count: 0,
      };
    default:
      return state;
  }
};
